import { ErrorPage, LoadingPage } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { FileDashboardDataFetcherMulti } from './FileDashboardDataFetcherMulti';
import { FileDashboardDataFetcherSingle } from './FileDashboardDataFetcherSingle';
import { useAppSelector } from '../../redux/hooks';
import { FileDashboardViewMulti } from './FileDashboardViewMulti';
import { FileDashboardViewSingle } from './FileDashboardViewSingle';

export const FileDashboardDirector = () => {
  const selectedPartnerNumberOrganization = useAppSelector(state => state.auth.user?.selectedPartnerNumberOrganization);
  const loadingChangeEmployer = useAppSelector(state => state.auth.loadingChangeEmployer);

  if (loadingChangeEmployer === ThunkRequestStatus.Pending) {
    return <LoadingPage />;
  }

  if (loadingChangeEmployer === ThunkRequestStatus.Rejected) {
    return <ErrorPage />;
  }

  if (!selectedPartnerNumberOrganization) {
    return (
      <FileDashboardDataFetcherMulti>
        <FileDashboardViewMulti />
      </FileDashboardDataFetcherMulti>
    );
  }

  return (
    <FileDashboardDataFetcherSingle>
      <FileDashboardViewSingle />
    </FileDashboardDataFetcherSingle>
  );
};
